import React from "react";

//Import Breadcrumb
import { Checkbox, FormControlLabel, FormHelperText, FormLabel, Radio, Stack } from "@mui/material";
import { grey } from "@mui/material/colors";

const CheckBox = ({ title, error, onChange, required, label, values, disabled }) => {

    return (
        <React.Fragment>
            <FormControlLabel control={<Checkbox
                checked={values || false}
                disabled={disabled}
                onChange={(e) => onChange(e)}
                sx={{
                    color: '#D0D0D0',
                    '&.Mui-checked': {
                        color: '#44d62c',
                    },
                }}
            />} label={<span className="text-semibold font-size-16" style={{color: '#00000099'}}>{label}</span>} />
            {error && <FormHelperText> {error}</FormHelperText>}


            {/* <Stack direction={"row"} alignItems={"center"}>
                <Radio
                    sx={{
                        '&.Mui-checked': {
                            color: "#009aff",
                        },
                    }}
                    checked={values}
                    onChange={(e) => onChange(e)}
                    value={label}
                    name="radio-buttons"
                />

                <FormLabel className="mb-0">{label}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>
            </Stack> */}


        </React.Fragment >
    );
};

export default CheckBox;
